<template>
  <va-accordion class="sidebar-accordion va-sidebar__menu__inner" v-model="accordionValue" multiply>
    <va-collapse v-for="(route, idx) in items" :key="idx">
      <template #header>
        <va-sidebar-item @click="showDasboard(route)" :active="isRouteActive(route)"
                         :to="route.children ? undefined : { name: route.name }">
          <va-sidebar-item-content>
            <va-icon v-if="route.name !='vote'" :name="route.meta.icon" class="va-sidebar-item__icon"/>
            <img :title="$t(route.displayName)" v-if="route.name=='vote'" src="@/static/images/heart.gif" height='30'
                 alt="">

            <va-sidebar-item-title>
              {{ $t(route.displayName) }}
            </va-sidebar-item-title>

            <va-icon v-if="route.children" :name="accordionValue[idx] ? 'expand_less' : 'expand_more'"/>
          </va-sidebar-item-content>
        </va-sidebar-item>
      </template>
      <template v-for="(child, index) in route.children" :key="index">
        <va-sidebar-item
          :active="isRouteActive(child)"
          :to="child.externalUrl ? undefined : { name: child.name }"
          @click="openExternalRoute(child)"
        >
          <va-sidebar-item-content>
            <div class="va-sidebar-item__icon"/>

            <va-sidebar-item-title>
              {{ $t(child.displayName) }}
            </va-sidebar-item-title>
          </va-sidebar-item-content>
        </va-sidebar-item>
      </template>
    </va-collapse>
  </va-accordion>
</template>

<script>
export default {
  name: "AppMenuAccordion",
  props: {
    items: {type: Array, default: () => []}
  },
  data() {
    return {
      accordionValue: [],
      url: '',
      url2: ''
    }
  },
  mounted() {
    this.accordionValue = this.items.map(i => this.isItemExpanded(i));
    this.loadUrl();
  },
  methods: {
    openExternalRoute(route) {
      if (route.externalUrl) {
        window.open(route.externalUrl, '_blank', 'noopener,noreferrer');
      }
    },
    showDasboard(route) {
      if (route.name === 'statistics') {
        window.open(this.url, '_blank');
      } else if (route.name === 'statisticsNew') {
        window.open(this.url2, '_blank');
      }
    },
    isGroup(item) {
      return !!item.children;
    },
    isRouteActive(item) {
      return item.name === this.$route.name;
    },
    isItemExpanded(item) {
      if (!item.children) {
        return false;
      }

      const isCurrentItemActive = this.isRouteActive(item);
      const isChildActive = !!item.children.find(child =>
        child.children ? this.isItemExpanded(child) : this.isRouteActive(child)
      );

      return isCurrentItemActive || isChildActive;
    },
    loadUrl() {
      this.$api.dashboardAPI.getTableauUrl()
        .then(res => {
          if (res.data.Success === false) {
            // VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.url = res.data.Data.split(',')[0];
          this.url2 = res.data.Data.split(',')[1];

        })
        .catch(error => {
          console.log(error);
        })
    }
  },

};
</script>

<style lang="scss" scoped>

</style>
